/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnInit} from '@angular/core';
import {AVAILABLE_SOON, I18nService} from '../../../_services/i18n.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-display-logos-available',
  templateUrl: './display-logos-available.component.html',
  styleUrls: ['./display-logos-available.component.scss']
})
export class DisplayLogosAvailableComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() oneLine: boolean;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private i18n: I18nService, private toastr: ToastrService) {
    this.oneLine = false;
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public soon(): void {
    this.toastr.info(this.i18n.get(AVAILABLE_SOON));
  }

}
